import { Injectable, OnDestroy } from '@angular/core';
import { FormConfigModel } from '../_models/Layout/FormConfig';
import { ListingParams } from '../_models/common/listingParams';
import { commonParams, SearchOptions } from '../_models/search/searchOptions';
@Injectable({
  providedIn: 'root'
})
export class ObjectCreaterService {
  constructor() {

  }
  public CreateFormConfig(): FormConfigModel {
    return {} as FormConfigModel;
  }
  public CreateListingParam(): ListingParams {
    let obj = {} as ListingParams;
    obj.customfieldValues = [];
    return obj;
  }
  public createSearchOptions(): SearchOptions {
    let searchOptions = {} as SearchOptions;
    searchOptions.LocationPreference = [];
    searchOptions.SpecialityPreference = [];
    searchOptions.departments = [];
    searchOptions.isView = false;
    searchOptions.jobStatusH = [];
    searchOptions.jobStatuses = [];
    searchOptions.locations = [];
    searchOptions.applicationStatusIds = [];
    searchOptions.employmentTypes = [];
    searchOptions.regions = [];
    searchOptions.categories = [];
    searchOptions.salaries = [];
    searchOptions.users = [];
    searchOptions.agencies = [];
    searchOptions.applicationStatuses = [];
    searchOptions.assessmentForms = [];
    searchOptions.skillCategories = [];
    searchOptions.skills = [];
    searchOptions.divisions = [];
    searchOptions.jobs = [];
    searchOptions.candidates = [];
    searchOptions.jobStatuses = [];
    searchOptions.jobLevels = [];
    searchOptions.jobAccess = [];
    searchOptions.talentPools = [];
    searchOptions.applicationStatusH = [];
    searchOptions.applicationStatusRej = [];
    searchOptions.applicationStatusesProg = [];
    searchOptions.advertIds = [];
    searchOptions.LocationPreference = [];
    searchOptions.SpecialityPreference = [];
    searchOptions.userIds = [];
    searchOptions.schoolLocations = [];
    searchOptions.division = [];
    searchOptions.formIds = [];
    searchOptions.documentIds = [];
    return searchOptions;
  }
  public createCommonParams(): commonParams {
    let commonParams = {} as commonParams;
    commonParams.statusids = [];
    commonParams.jobStatusesids = [];
    commonParams.employementTypesids = [];
    commonParams.locationsids = [];
    commonParams.departmentids = [];
    commonParams.userIds = [];
    commonParams.divisionIds = [];
    commonParams.applicationStatuseids = [];
    commonParams.applicationStatuseidsH = [];
    commonParams.jobids = [];
    commonParams.applicationRejectStatuseids = [];
    commonParams.applicationInprogressStatuseids = [];
    commonParams.agenciesIds = [];
    commonParams.usersids = [];
    commonParams.jobStatusesidsH = [];
    commonParams.advertIds = [];
    commonParams.userids = [];
    commonParams.regionIds = [];
    commonParams.documentIds = [];
    commonParams.formIds= [];
    return commonParams;
  }
}
